import React from 'react';
import classNames from 'classnames';
/**
 * Bronson [OrderedList](https://bronson.vwfs.io/bluelabel/components/detail/bronson-ordered-list.html) component is an ordinary `<ol>` element,
 * used for normal numeration lists in editorial content.
 */
export const OrderedList = ({ children, nestedCounter, testId, ...otherProps }) => {
    const olClassNameList = classNames({
        'c-ol': !nestedCounter,
        'c-list-nested-counter': nestedCounter,
    }).trim();
    return (React.createElement("ol", { ...otherProps, "data-testid": testId, className: olClassNameList }, children));
};
OrderedList.displayName = 'OrderedList';
/**
 * The OrderedListItem component (nested) is used to wrap
 * the item content and display it inside the {@link OrderedList}.
 */
export function OrderedListItem({ children, ...otherProps }) {
    return React.createElement("li", { ...otherProps }, children);
}
OrderedListItem.displayName = 'OrderedList.Item';
OrderedList.Item = OrderedListItem;
